import React from "react";
import { useSelector } from "react-redux";
import { Empty } from "antd";

import { Spacer, meeting } from "../../components";

const StudentMeetings = () => {
  const { student } = useSelector((state) => state?.students);
  return (
    <div className="px-6 py-4">
      <div className="student-headers">Upcoming Meetings</div>
      <Spacer height={20} />
      <div>
        {student?.meetings?.upcomingMeetings?.length === 0 ? (
          <div className="p-6">
            <Empty />
          </div>
        ) : (
          student?.meetings?.upcomingMeetings?.map((item, index) => (
            <meeting.MeetingRow item={item} index={index} key={index} />
          ))
        )}
      </div>
      <Spacer height={20} />
      <div className="student-headers">Past Meetings</div>
      <Spacer height={20} />
      <div>
        {student?.meetings?.pastMeetings?.length === 0 ? (
          <div className="p-6">
            <Empty />
          </div>
        ) : (
          student?.meetings?.pastMeetings?.map((item, index) => (
            <meeting.MeetingRow item={item} index={index} key={index} />
          ))
        )}
      </div>
    </div>
  );
};

export default StudentMeetings;
